export const build = { date:"2026-03-25.1202", stage:"alpha" }
